import api from '@/services/api'

export default {
    fetchProducts(params) {
        return api.get(`catalog/products/`, {params})
            .then(response => response.data)
    },
    fetchProductsList(payload) {
        return api.post(`catalog/products/list/`, payload)
            .then(response => response.data)
    },
    getProduct(params) {
        return api.get(`catalog/products/${params.id}/`, {params})
            .then(response => response.data)
    },
    searchByImageProducts(data, token) {
        return api.postForm(`catalog/products/search-by-image/`, data, {cancelToken: token})
            .then(response => response.data)
    }
}